import React from "react";
import ErrorMessageLabel from "pages/authorization/signin/error-message/error-message-label";
import s from "./ask-expert.module.scss";
import EchoButton from "pages/landing-page/items/echo-button/echo-button";
import 'react-phone-number-input/style.css'
import Input from 'react-phone-number-input/input'


import { useState } from "react";

const AskExpert = (props) => {

    const [name, setName] = useState(null);
    const [phone, setPhone] = useState(null);
    const [scopeActivity, setScopeActivity] = useState(null);
    const [message, setMessage] = useState(null);
    const [nameError, setNameError] = useState(null);
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [isGetDemoSuccess, setIsGetDemoSuccess] = useState(props.isDemoSuccess);
    const [value, setValue] = useState();
    const [email, setEmail] = useState(props.email ? props.email : null); 
    const phoneRegExp = /^(\+?\d{11})$/;
    const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const [isEmailValid, setIsEmailValid] = useState(null);

    const checkPhoneNumber = (phoneNumber) => {
        if(phoneNumber && phoneNumber.match(phoneRegExp)){
            return true;
        }
        else{
            return false;
        }
    }

    const checkEmail = (email) => {
        if(!email || email && email.match(emailRegExp)){
            //setIsEmailValid(null);
            //setRerender(!rerender)
            return true
        }
        else{
            
            //setRerender(!rerender)
            return false
        }
    }

    const inputChangeName = (e) => {
        let value = e.target.value;
        setName(value);
    }

    const inputChangeScopeActivity = (e) => {
        let value = e.target.value;
        setScopeActivity(value);
    }

    const inputChangePhone = (e) => {
        let value = e.target.value;
        setPhone(value);
    }

    const inputChangeEmail = (e) => {
        let value = e.target.value;
        setEmail(value);
    }

    const textreaMessage = (e) => {
        let value = e.target.value;
        setMessage(value);
    }

    const checkIsNumber = (e) => {
        if(isNaN(e.key)){
            setPhoneNumberError(props.getValue('ONLY_NUMBER'));
        }
        if(phone){
            setPhoneNumberError(NULL);
        }
    }

    const sendMessage = () => {
        if(isGetDemoSuccess){
            props.modalShowToggle(false);
        }
        if(!name){ 
            setNameError(props.getValue('FIELD_NOT_BE_EMPTY'));
        }
        else if(!checkPhoneNumber(value)){
            setPhoneNumberError(props.getValue('ONLY_NUMBER'));
        }
        else if(!checkEmail(email)){
            setIsEmailValid(props.getValue("NOT_VALID_EMAIL"));
            //setIsEmailValid(false);
        }
        else{
            props.sendMessage(name, value, 'CALL_TO_ACTION', message, scopeActivity, email);
            setName(null);
            setScopeActivity(null);
            setValue(null);
            setMessage(null);
            setPhoneNumberError(null);
            setNameError(null);
            setEmail(null);
        }
    }

    const returnBack = () => {
        props.setIsDemoSuccess(false);
    }

    const setMenu = (selected) => {
        props.setMenuActive(selected);
    }

    const textBlock =   <div className={s.textBlock}>
                            <div className={s.titleBlock}>
                                <span className={s.whiteText}>{props.selectedLanguage !== 'KAZ' ? props.getValue('ASK') : props.getValue('EXPERT')} </span>
                                <span className={s.blueText}>{props.selectedLanguage !== 'KAZ' ? props.getValue('EXPERT') : props.getValue('ASK')}</span>
                            </div>
                            <span className={s.descriptionText}>{ props.getValue('HAS_QUESTIONS') }</span>
                        </div>

    const inputBlocks = <div className={s.inputTextBlocks}>
                            <div className={s.inputBlock}>
                                { nameError ? <div className={s.errorBlock}><ErrorMessageLabel message={nameError} /></div> : null }
                                <input className={nameError ? s.errorInput : null} onChange={inputChangeName} value={name} type={'text'} placeholder={props.getValue('NAME')}/>
                            </div>
                            <div className={s.inputBlock}>
                                <input onChange={inputChangeScopeActivity} value={scopeActivity} type={'text'} placeholder={props.getValue('SCOPE_ACTIVITY')} />
                            </div>
                            <div className={s.inputBlock}>
                            <Input
                                country="KZ"
                                international
                                withCountryCallingCode
                                value={value}
                                placeholder={props.getValue('TELEPHONE')}
                                onChange={setValue}
                            />
                            { /*phoneNumberError ? <div className={s.errorBlock}><ErrorMessageLabel message={phoneNumberError} /></div> : null }
                                <input className={phoneNumberError ? s.errorInput : null} onChange={inputChangePhone} value={phone} type={'text'} placeholder={props.getValue('TELEPHONE')} />*/}
                            </div>
                        </div>

    const textAreaBlock = <textarea onChange={textreaMessage} rows={3} placeholder={props.getValue('YOUR_QUESTION')}></textarea>

    const privacyPolicy = <div className={s.privacyPolicyAgreement}>
                                <span className={s.whiteColor}>{ props.getValue('ON_PRESSING_SUBMIT') }</span>
                                <a className={s.activeMenu} onClick={setMenu.bind(this, 'PRIVACY_POLICY')}><span className={s.blueColor}>{ props.getValue('PRIVACY_POLICY') } </span></a>
                                <span className={s.whiteColor}> { props.getValue('PROCESSING_PERSONAL_DATA') }</span>
                            </div>

    const submitButtonBlock = <div className={s.buttonBlock}>
                                <EchoButton disabled={!checkPhoneNumber(value) || name == null || name == "" || !checkEmail(email)} callback={sendMessage} title={ props.getValue('SUBMIT') } styles={{background: "white"}} textStyles={{color: "#1A3950"}} />
                            </div>

    const AskExpertBlock = !props.isDemoSuccess
                            ?   <div className={s.AskExpert}>
                                    { textBlock }
                                    <div className={s.InputBlocks}>
                                        { inputBlocks }
                                        <div className={s.inputTextBlocks}>
                                            <div className={s.inputBlock +" "+ s.fullInputBlock}>
                                            { isEmailValid ? <div className={s.errorBlock}><ErrorMessageLabel message={isEmailValid} /></div> : null }
                                                <input onChange={inputChangeEmail} value={email} placeholder={props.getValue('EMAIL_ADDRESS')} type={'text'}/>
                                            </div>
                                        </div>

                                        { textAreaBlock }
                                        { privacyPolicy }
                                        { submitButtonBlock }
                                    </div>
                                </div>
                            :   <div className={s.AskExpert}>
                                    <div className={s.MessageSuccessSended}>
                                        <span>{ props.getValue('SEND_MESSAGE_SUCCESS')}</span>
                                        <div className={s.buttonBlock}>
                                            <EchoButton callback={returnBack} title={ props.getValue('RETURN') } styles={{background: "white"}} textStyles={{color: "#1A3950"}} />
                                        </div>
                                    </div>
                                </div>

    
    return (
        <React.Fragment>
            { AskExpertBlock }
        </React.Fragment>
    )
}

export default AskExpert;